import "@mux/mux-player";
import { Component, OnInit, inject, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { Video } from "../../../entities/videos/video";
import { VideosService } from "../videos.service";
import { MatIcon } from "@angular/material/icon";
import { VideoChapter } from "../../../entities/videos/video-chapter";
import { NgxTolgeeModule } from "@tolgee/ngx";
import { first } from "rxjs";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { UserService } from "../../../services/user.service";
import { environment } from "../../../../environments/environment";

@Component({
	selector: "app-video-player",
	templateUrl: "./video-player.component.html",
	styleUrls: ["./video-player.component.scss"],
	imports: [MatDialogTitle, MatIcon, MatDialogClose, MatDialogContent, NgxTolgeeModule, MatProgressSpinner],
	changeDetection: ChangeDetectionStrategy.Eager,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VideoPlayerComponent implements OnInit {
	data = inject<Video>(MAT_DIALOG_DATA);
	private videosService = inject(VideosService);
	private userService = inject(UserService);

	playbackUrl: string | null = null;
	thumbnailUrl: string | null = null;
	isProcessing = false;
	readonly muxEnvKey = environment.muxDataEnvKey;
	readonly viewerUserId = this.userService.getUserId();
	readonly playerInitTime = Date.now();

	static readonly STATUS_PROCESSING = 2;

	ngOnInit(): void {
		if (this.data.status === VideoPlayerComponent.STATUS_PROCESSING) {
			this.isProcessing = true;
			return;
		}
		this.videosService
			.getVideoData(this.data.id)
			.pipe(first())
			.subscribe(({ playbackUrl, thumbnailUrl }) => {
				this.playbackUrl = playbackUrl;
				this.thumbnailUrl = thumbnailUrl;
			});
	}

	goTo(chapter: VideoChapter): void {
		const player = document.querySelector("mux-player") as any;
		if (player) {
			player.currentTime = chapter.position;
		}
	}
}
